// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"k--z","refreshPageWarning":"l--z","redirectMessageText":"m--z"};